export const wrapperIdentifier = 'vinculationEnvironment';
